module.exports = __webpack_public_path__ + "static/media/5.def36a0c.mp3";